import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const inputErrorFn = /* @__PURE__ */ createRecipe('input-error', {}, [])

const inputErrorVariantMap = {}

const inputErrorVariantKeys = Object.keys(inputErrorVariantMap)

export const inputError = /* @__PURE__ */ Object.assign(memo(inputErrorFn.recipeFn), {
  __recipe__: true,
  __name__: 'inputError',
  __getCompoundVariantCss__: inputErrorFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: inputErrorVariantKeys,
  variantMap: inputErrorVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, inputErrorVariantKeys)
  },
  getVariantProps: inputErrorFn.getVariantProps,
})